// Part of the Chili3d Project, under the AGPL-3.0 License.
// See LICENSE file in the project root for full license information.

import { Locale } from "./i18n";

export default {
    display: "Português - Brasil",
    code: "pt-BR",
    translation: {
        "arc.angle": "Ângulo",
        "arc.start": "Início",
        "axis.x": "Eixo X",
        "axis.y": "Eixo Y",
        "axis.z": "Eixo Z",
        "body.arc": "Arco",
        "body.bolean": "Boolean",
        "body.box": "Caixa",
        "body.pyramid": "Pirâmide",
        "body.cylinder": "Cilindro",
        "body.cone": "Cone",
        "body.group": "Group",
        "body.sphere": "Esfera",
        "body.ellipse": "Ellipse",
        "body.circle": "Circle",
        "body.face": "Face",
        "body.fuse": "Fuse",
        "body.imported": "Imported",
        "body.line": "Line",
        "body.polygon": "Pline",
        "body.prism": "Prisma",
        "body.rect": "Retângulo",
        "body.revol": "Revolve",
        "body.sweep": "Sweep",
        "body.wire": "Wire",
        "box.dx": "Comprimento",
        "box.dy": "Largura",
        "box.dz": "Altura",
        "body.editableShape": "Forma Editável",
        "body.meshNode": "Nó Mesh",
        "body.multiShape": "Multi Formas",
        "circle.center": "Centro",
        "circle.radius": "Raio",
        "ellipsoid.radiusX": "RaioX",
        "ellipsoid.radiusY": "RaioY",
        "ellipsoid.radiusZ": "RaioZ",
        "ellipse.majorRadius": "major Radius",
        "ellipse.minorRadius": "minor Radius",
        "command.act.alignCamera": "Alinhar Câmera",
        "command.boolean.common": "Interseção",
        "command.boolean.cut": "Cortar",
        "command.boolean.join": "Mesclar",
        "command.convert.fuse": "Fundir",
        "command.convert.revol": "Revolve",
        "command.convert.sweep": "Sweep",
        "command.convert.toFace": "Para Face",
        "command.convert.toShell": "Para Casca",
        "command.convert.toSolid": "Para Sólido",
        "command.convert.toWire": "Para Wireframe",
        "command.convert.curveProjection": "Projeção",
        "command.create.arc": "Arco",
        "command.create.bezier": "Bezier",
        "command.create.box": "Caixa",
        "command.create.circle": "Círculo",
        "command.create.cone": "Cone",
        "command.create.copyShape": "Copiar Forma",
        "command.create.cylinder": "Cilindro",
        "command.create.ellipse": "Elipse",
        "command.create.ellipsoid": "Elipsóide",
        "command.create.extrude": "Extrusão",
        "command.create.folder": "Criar Pasta",
        "command.create.group": "Agrupar",
        "command.create.line": "Linha",
        "command.create.offset": "Deslocar",
        "command.create.polygon": "Polilinha",
        "command.create.pyramid": "Piramide",
        "command.create.rect": "Retângulo",
        "command.create.section": "Criar Seção",
        "command.create.sphere": "Esfera",
        "command.create.thickSolid": "Thick Solid",
        "command.doc.new": "Novo Documento",
        "command.doc.open": "Abrir Documento",
        "command.doc.save": "Salvar Documento",
        "command.doc.saveToFile": "Salvar para Arquivo",
        "command.edit.redo": "Refazer",
        "command.edit.undo": "Desfazer",
        "command.file.export": "Exportar",
        "command.file.import": "Importar",
        "command.measure.angle": "Angle",
        "command.measure.length": "Length",
        "command.measure.select": "Select",
        "command.modify.array": "Array",
        "command.modify.break": "Break",
        "command.modify.brushAdd": "Brush Add",
        "command.modify.brushRemove": "Brush Remove",
        "command.modify.brushClear": "Brush Clear",
        "command.modify.chamfer": "Chamfer",
        "command.modify.deleteNode": "Delete Node",
        "command.modify.explode": "Explode",
        "command.modify.fillet": "Fillet",
        "command.modify.mirror": "Mirror",
        "command.modify.move": "Move",
        "command.modify.removeFeature": "Remove Feature",
        "command.modify.removeShapes": "Remove Shapes",
        "command.modify.rotate": "Rotate",
        "command.modify.split": "Split",
        "command.modify.trim": "Trim",
        "command.special.last": "__Last_COMMAND__",
        "command.test.performance": "Performance Test",
        "command.wechat.group": "Wechat",
        "command.workingPlane.alignToPlane": "Align",
        "command.workingPlane.fromSection": "Section",
        "command.workingPlane.set": "Set",
        "command.workingPlane.toggleDynamic": "Toggle",
        "common.angle": "Angle",
        "common.area": "Area",
        "common.back": "Back",
        "common.language": "Language",
        "common.count": "Count",
        "common.isGroup": "Group",
        "common.numberX": "Number X",
        "common.numberY": "Number Y",
        "common.numberZ": "Number Z",
        "common.3DNavigation": "3D Navigation",
        "common.theme": "Theme",
        "common.theme.light": "Light",
        "common.theme.dark": "Dark",
        "common.theme.system": "System",
        "common.cancel": "Cancel",
        "common.clone": "Clone",
        "common.color": "Color",
        "common.confirm": "Confirm",
        "common.general": "General",
        "common.length": "Length",
        "common.dir": "Direction",
        "common.material": "Material",
        "common.matrix": "Matrix",
        "common.name": "Name",
        "common.normal": "Normal",
        "common.opacity": "Opacity",
        "common.thickness": "Thickness",
        "common.type": "Type",
        "common.volume": "Volume",
        "dialog.title.selectWorkingPlane": "Select Working Plane",
        "entity.editable": "Editable Entity",
        "entity.parameter": "Parameter Entity",
        "error.default:{0}": "error: {0}",
        "error.input.cannotInputANumber": "Overlap with reference point, 1 number cannot be entered",
        "error.input.invalidNumber": "Please enter a valid number, separated by ,",
        "error.input.threeNumberCanBeInput": "Reference point is empty, only 3 numbers can be entered",
        "error.input.unsupportedInputs": "Exceeds the maximum number of inputs",
        "error.import.unsupportedFileType:{0}": "Unsupported file type: {0}",
        "error.export.noNodeCanBeExported": "No node can be exported",
        "file.format": "Format",
        "home.recent": "Recent",
        "home.welcome": "Bem-vindo ao Bitcoin 3D",
        "items.header": "Items",
        "items.tool.delete": "Delete",
        "items.tool.expandAll": "Expand All",
        "items.tool.newFolder": "New Folder",
        "items.tool.unexpandAll": "Unexpand all",
        "line.end": "End",
        "line.start": "Start",
        "line.type.line": "Line",
        "line.type.xline": "XLine",
        "material.texture.image": "Image",
        "material.texture.rotation": "Rotation",
        "material.texture.wrapS": "Wrap S",
        "material.texture.wrapT": "Wrap T",
        "material.texture.repeat": "Repeat",
        "material.texture.offset": "Offset",
        "material.map": "Map",
        "material.specular": "Specular",
        "material.shininess": "Shininess",
        "material.emissive": "Emissive",
        "material.specularMap": "Specular Map",
        "material.normalMap": "Normal Map",
        "material.bumpMap": "BumpMap",
        "material.roughnessMap": "Roughness Map",
        "material.emissiveMap": "Emissive Map",
        "material.metalness": "Metalness",
        "material.metalnessMap": "Metalness Map",
        "material.roughness": "Roughness",
        "model.visible": "Visible",
        "option.command.circularPattern": "Circular Pattern",
        "option.command.repeat": "Repeat",
        "option.command.isFace": "Face",
        "option.command.isRoundCorner": "Round Corner",
        "option.command.thickness": "Thickness",
        "option.command.isConnected": "Connected",
        "option.command.isConvertInstance": "Convert Instance",
        "option.command.insertPoint": "Insert Point",
        "polygon.points": "Points",
        "prompt.default{0}{1}":
            "{0} to pan the view, {1} to rotate the view, Mouse wheel to scroll the zoom view",
        "prompt.deleteDocument{0}": "Do you want to delete {0}?",
        "prompt.pickCircleCenter": "pick center, ESC key to cancel",
        "prompt.pickFistPoint": "Pick first point, ESC key to cancel",
        "prompt.pickNextPoint": "pick next point, ESC key to cancel",
        "prompt.pickRadius": "input radius, ESC key to cancel",
        "prompt.polygon.close": "Close",
        "prompt.saveDocument{0}": "Do you want to save the changes to {0}?",
        "prompt.select.edges": "Please select edges",
        "prompt.select.faces": "Please select faces",
        "prompt.select.models": "Please select models",
        "prompt.select.noModelSelected": "No model selected",
        "prompt.select.section": "Please select section",
        "prompt.select.shape": "Please select shape",
        "prompt.select.solids": "Please select solids",
        "prompt.select.path": "Please select path",
        "prompt.select.vertexes": "Please select vertexes",
        "prompt.select.wires": "Please select wires",
        "toast.snap.notFoundValidPoint": "No valid point",
        "properties.group.transform": "Transform",
        "properties.header": "Properties",
        "properties.multivalue": "Multi Value",
        "rect.dx": "Length",
        "rect.dy": "Width",
        "ribbon.group.2d": "2D",
        "ribbon.group.3d": "3D",
        "ribbon.group.act": "Act",
        "ribbon.group.boolean": "Boolean",
        "ribbon.group.converter": "Converter",
        "ribbon.group.draw": "Sketch",
        "ribbon.group.importExport": "Import/Export",
        "ribbon.group.measure": "Measure",
        "ribbon.group.modify": "Modify",
        "ribbon.group.other": "Other",
        "ribbon.group.selection": "Selection",
        "ribbon.group.tools": "Tools",
        "ribbon.group.workingPlane": "Working Plane",
        "ribbon.tab.draw": "Sketch",
        "ribbon.tab.file": "File",
        "ribbon.tab.tools": "Tools",
        "ribbon.tab.startup": "Startup",
        "snap.center": "Center",
        "snap.end": "End",
        "snap.intersection": "Intersection",
        "snap.mid": "Middle",
        "snap.perpendicular": "Perpendicular",
        "snap.nearest": "Nearest",
        "statusBar.snap": "Snap",
        "statusBar.tracking": "Tracking",
        "toast.command.{0}excuting": "Command {0} is runing",
        "toast.converter.error": "Converter error",
        "toast.converter.invalidColor": "The color is invalid",
        "toast.delete{0}Objects": "Deleted {0} objects",
        "toast.document.noActivated": "No document activated",
        "toast.document.saved": "Document saved",
        "toast.downloading": "Downloading",
        "toast.excuting{0}": "Excuting {0}",
        "toast.fail": "Fail",
        "toast.read.error": "Read error",
        "toast.select.noSelected": "No selected",
        "toast.success": "Success",
        "transform.rotation": "Rotation",
        "transform.scale": "Scale",
        "transform.translation": "Translation",
        "vertex.point": "Point",
        "viewport.orthographic": "Orthographic",
        "viewport.perspective": "Perspective",
        "viewport.fitContent": "Fit Content",
        "viewport.zoomIn": "Zoom In",
        "viewport.zoomOut": "Zoom Out",
    },
} satisfies Locale;
